<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div class="kt-portlet__body">
      <div class="kt-widget4">
        <div v-for="(data, index) in mixcloud_cloudcasts.data" :key="index" class="kt-widget4__item">
          <span class="kt-widget4__pic">
            <img class="kt-widget4__img" :src="data.pictures.large" alt="thumbnail">
          </span>
          <a target="_blank" :href="data.url" class="kt-widget4__title kt-widget4__title--light">
            {{ data.name }}
          </a>
          <div class="mixcloud-stats kt-widget4__number kt-font-info">
            <span title="Favourites" class="mixcloud-icon"> <i class="flaticon-star" /> {{ data.favorite_count }} </span>
            <span title="Listeners" class="mixcloud-icon"> <i class="flaticon-users-1" /> {{ data.listener_count }} </span>
            <span title="Plays" class="mixcloud-icon"> <i class="flaticon-music" /> {{ data.play_count }} </span>
            <span title="Reposts" class="mixcloud-icon"> <i class="flaticon2-reply" /> {{ data.repost_count }} </span>
            <span title="Comments" class="mixcloud-icon"> <i class="flaticon-comment  kt-font-default" /> {{ data.comment_count }} </span>
          </div>
          <div class="mixcloud-stats-mobile kt-widget4__number kt-font-info">
            <span title="Favourites" class="mixcloud-icon"> <i class="flaticon-star" /> {{ data.favorite_count }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    mixcloud_cloudcasts: window.mixcloud_cloudcasts,
  }),
};
</script>

<style lang="scss" scoped>
@use "sass:map";

@use "~AssetsSass/_variables" as *;

  .mixcloud-icon {
      color: map.get($ss-theme, 'teal-blue');
      font-size: 1em;
      padding: 5px;
    }

  @media only screen and (min-width: 600px) {
  .mixcloud-stats-mobile {
    display: none;
  }
  .mixcloud-stats {
    display: block;
  }

}

@media only screen and (max-width: 600px) {
  .mixcloud-stats-mobile {
    display: block;
  }
  .mixcloud-stats {
    display: none;
  }

}

</style>
